/** Corporate transfer top-up /metering/finance/corporate-recharge (corporateRecharge.vue) */
export default {
  corporateRechargePage: {
    emptyNoViewPerm: 'No permission to view',
    tabNavAria: 'Finance module tabs',
    tabPublic: 'Corporate top-up',
    tabBank: 'Bank connectivity',
    phDateStart: 'Start',
    phDateEnd: 'End',
    phTenant: 'Tenant name / ID',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sectionTitle: 'Corporate top-up',
    btnRecharge: 'Corporate top-up',
    sortDefault: 'Default sort',
    colSeqNo: 'Transaction no.',
    colOccurTime: 'Time',
    colTenant: 'Tenant',
    colRechargeAccount: 'Account',
    colAmount: 'Amount',
    colPayeeName: 'Remitter account name',
    colBankNumber: 'Remitter account no.',
    colTransferRemark: 'Transfer note',
    colStatus: 'Status',
    colAction: 'Actions',
    btnView: 'View',
    dialogTitleRecharge: 'Corporate top-up',
    dialogTitleVoucher: 'Receipt images',
    formProjectName: 'Project',
    phSelectProject: 'Select project',
    formTenantName: 'Tenant',
    phSelectTenant: 'Select tenant',
    formTradeType: 'Trade type',
    phSelectTradeType: 'Select trade type',
    tradeTypeTenantCharge: 'Tenant top-up',
    formBizType: 'Business type',
    bizElectric: 'Electricity',
    bizWater: 'Water',
    formAmount: 'Amount',
    phAmount: 'Enter amount',
    suffixYuan: 'CNY',
    formBankType: 'Bank',
    phSelectBankType: 'Select bank',
    formRemark: 'Remark',
    phRemark: 'Enter remark (max 200)',
    formVoucher: 'Receipts',
    uploadTip: 'JPG/PNG, max 2MB each, up to 5 files',
    btnCancel: 'Cancel',
    btnConfirmRecharge: 'Submit',
    btnSubmitting: 'Submitting…',
    shortcutYesterday: 'Yesterday',
    shortcutThisWeek: 'This week',
    shortcutLastWeek: 'Last week',
    shortcutThisMonth: 'This month',
    shortcutLastMonth: 'Last month',
    shortcutLast3Months: 'Last 3 months',
    shortcutLastYear: 'Last year',
    statusNormal: 'Active',
    statusRevoked: 'Revoked',
    accountElectric: 'Electricity wallet',
    accountWater: 'Water wallet',
    bankZGYH: 'Bank of China',
    bankPFYH: 'SPD Bank',
    bankZGYHSZ: 'Bank of China',
    bankZHSHYH: 'CMB',
    bankZXYH: 'CITIC Bank',
    bankNBYH: 'Bank of Ningbo',
    msgTenantListFail: 'Failed to load tenants',
    msgFetchFail: 'Failed to load data',
    msgFetchRecordFail: 'Failed to load top-up records',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Exported {count} row(s).',
    msgExportFail: 'Export failed',
    exportSheetName: 'Corporate top-up',
    filePrefix: 'CorporateTopUp',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Select rows to export first',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: 'Over {total} rows matched; exported first {count}.',
    exporting: 'Exporting…',
    msgNoOperatePerm: 'No permission to operate',
    msgNoPublicRechargePerm: 'This project has no corporate top-up permission',
    msgConfirmSubmit: 'Submit this top-up request?',
    confirmTitle: 'Notice',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    msgSubmitSuccess: 'Request submitted',
    msgPayFail: 'Top-up failed',
    msgRechargeFail: 'Top-up failed',
    msgUploadSuccess: 'Uploaded',
    msgUploadFail: 'Upload failed',
    ruleSelectProject: 'Select a project',
    ruleSelectTenant: 'Select a tenant',
    ruleSelectTradeType: 'Select trade type',
    ruleSelectBizType: 'Select business type',
    ruleAmountRequired: 'Enter amount',
    ruleAmountInvalid: 'Enter a valid amount',
    ruleAmountPositive: 'Amount must be greater than 0',
    ruleAmountMax: 'Amount cannot exceed 999999.99',
    ruleSelectBankType: 'Select a bank'
  }
}
